import { KText } from '@/ui-library/components/text';
import { Flex } from '@chakra-ui/react';

export const createLabelForSelect = (
  val,
  createPlaceHolder = 'Create as new option and add',
  options = []
) => {
  if (!val) return null;
  let isExistingOption = {};
  isExistingOption = options?.find((option) => option.label === val);
  if (isExistingOption) {
    setTimeout(() => {
      const element = document.getElementById(
        `react-select-2-option-${options.length}`
      );
      if (element) {
        element.style.display = 'none';
      }
    }, 50);
  } else {
    return (
      <Flex gap="6px">
        <KText
          wordBreak="break-all"
          as="span"
          color="secondary-900"
          size="sm-semi-bold"
        >
          {val}
        </KText>
        <KText as="span" w="fit-content">
          {createPlaceHolder}
        </KText>
      </Flex>
    );
  }
};
